<template>
  <div id="video">
    <!-- 搜索框 -->
    <div class="top_input">
      <div class="title">
        <i></i>
        {{ title }}
      </div>
      <div class="info">
        <span @click="goRout">{{ info }}</span>
        <el-button v-if="userInfo.rules && userInfo.rules.includes('1')" @click="clickLive" type="warning" size="mini">
          主播模式
        </el-button>
        <!-- <a href="/help?id=1">如何获取Steam17位ID并开启库存?</a> -->
      </div>

      <div class="input_b">
        <div v-if="liveTypes === 0" class="input_b_b left" @click="accountValuate">人工估值</div>
        <input :class="{ active: liveTypes === 1 }" class="input_b_i" type="text" maxlength="80" v-model="form.steam_id" placeholder="请输入Steam17位ID或者库存网页URL" @keyup="onKeyUp" />
        <div class="input_b_b" @click="sumbit">显示库存</div>
      </div>
      <div class="radio_body">
        <label class="radio">
          <span v-if="liveTypes === 0">隐藏无价值物品</span>
          <span v-else>隐藏物品</span>
          <input type="radio" v-model="form.hide" name="radio" value="1" checked />
          <i></i>
        </label>
        <label class="radio">
          <span v-if="liveTypes === 0">显示无价值物品</span>
          <span v-else>显示物品</span>
          <input type="radio" v-model="form.hide" value="0" name="radio" />
          <i></i>
        </label>
      </div>
    </div>

    <div class="test">
      <div class="autoplay">
        <swiper :options="swiperOption" ref="videoSwiper" v-if="initOrNot" navigation>
          <swiper-slide v-for="(item, index) in imgList" :key="index">
            <video v-if="facility == 'pc'" style="width: 100%" ref="videoPlayer" :src="item.video_file" :poster="item.video_file + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0,m_fast'" muted @ended="endVideo(index)" preload="none" class="multimedia"></video>
            <img v-else :src="item.pic_image" class="multimedia" />
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <img v-else class="multimedia" :src="require('@/assets/img/home_top.png')" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
//页面引入swiper
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getPaymentCheck } from '@/api/payment.js'
import { set, get } from "../utils/tools";
import { mapState } from "vuex";

import { getPubgCode, accountValuate } from "@/api/finalize.js";

export default {
  name: "VideoSD",
  components: { swiper, swiperSlide },
  data () {
    return {
      loginShow: false,
      facility: "",
      mediaLastIndex: 0,
      time: 30000, //轮播切换时间
      swiperOption: {
        speed: 1000,
        loop: false,
        observer: true,
        observeParents: true,
        autoplayDisableOnInteraction: false,
        allowTouchMove: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: () => {
            this.slideChangeTransitionEndHandle();
          },
          slideChangeTransitionStart: () => {
            this.slideChangeTransitionStartHandle();
          },
          //控制第一个slide切换
          init: () => {
            this.initHandle();
          },
        },
      },
      form: {
        hide: 1,
        // steam_id: '76561199470533213',
        steam_id: "",
        number: "10000",
      },
      title: "",
      info: "", // 标题下方说明文字
      initOrNot: false, //imgList数据改变的时候确保swiper会init一次
      imgList: [],
      help_id: 1,
      wechatImage: "",
    };
  },
  created () {
    this.facility = sessionStorage.getItem("facility");
    this.getBanner();
  },
  activated () {
    this.initHandle();
  },
  mounted () {
    let that = this;
  },
  computed: {
    ...mapState(["token", "userInfo", "liveTypes"]),
  },
  methods: {
    onKeyUp (e) {
      // console.log(e, "e");
      this.form.steam_id = this.form.steam_id.replace(/\s*/g, "");
      if (e.key == "Enter") {
        if (this.$store.state.login == 1) {
          this.$message({
            message: "请先进行登录",
            type: "warning",
          });
          this.$store.commit("setLoginShow", 1);
          return;
        }
        this.sumbit();
      }
    },
    goRout () {
      location.href = "/help";

      // this.$router.push({
      //   path: "/help",
      //   query: {
      //     id: this.help_id,
      //   },
      // });
    },
    // 估值
    accountValuate () {
      if (this.form.steam_id) {
        if (this.$store.state.login == 1) {
          this.$message({
            message: "请先进行登录",
            type: "warning",
          });
          this.$store.commit("setLoginShow", 1);
          return;
        }
        if (this.form.steam_id.length > 40 && this.form.steam_id.split("/")) {
          // console.log("格式1正确");
          this.form.steam_id = this.form.steam_id.split("/")[4];
        } else if (this.form.steam_id.length > 17 && this.form.steam_id.replace(/[ ]/g, "")) {
          // console.log("格式2正确");
          this.form.steam_id = this.form.steam_id.replace(/[ ]/g, "");
        } else if (this.form.steam_id.length == 17 && !this.form.steam_id.replace(/[ ]/g, "")) {
          // console.log("格式3正确");
          this.form.steam_id = this.form.steam_id.replace(/[ ]/g, "");
        } else if (this.form.steam_id.length == 17) {
          // console.log("格式3正确");
          this.form.steam_id = this.form.steam_id.replace(/[ ]/g, "");
        } else {
          return this.$message({
            message: "输入格式不正确，请重新输入",
            type: "warning",
          });
        }

        let data = {
          steam_id: set(this.form.steam_id),
          token: this.token,
        }
        // console.log(data);
        accountValuate(data).then(res => {
          // console.log(res);
          this.$alert(`
          <div>${res.msg}</div>
          <div style="margin: 10px 0 0;">
            <img src="${this.wechatImage}" width="100%" alt="" />
          </div>`, "提示", {
            dangerouslyUseHTMLString: true,
          });
        })
      } else {
        this.$alert(`
          <div>人工估值请添加微信</div>
          <div style="margin: 10px 0 0;">
            <img src="${this.wechatImage}" width="100%" alt="" />
          </div>`, "提示", {
          dangerouslyUseHTMLString: true,
        });
      }
    },
    sumbit () {
      const _this = this
      if (this.$store.state.login == 1) {
        this.$message({
          message: "请先进行登录",
          type: "warning",
        });
        this.$store.commit("setLoginShow", 1);
        return;
      }
      let steamId = this.form.steam_id.replace(/[ ]/g, "");
      let str = `${steamId.slice(0, 4)}-${steamId.slice(4, 6)}-${steamId.slice(6, 8)}`;
      let date = this.strDateTime(str);

      if (date) {
        getPubgCode({ code: steamId }).then(res => {
          // console.log(res);
          if (res.code == 1) {
            let id = `${encodeURIComponent(set(res.data))}`, { href } = this.$router.resolve({ name: "finalize", query: { id } });
            if (this.facility == "pc") {
              window.open(href, "_blank");
            } else {
              this.$router.push(`/finalize?id=${id}`);
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
        return false;
      }

      if (this.form.steam_id.length > 40 && this.form.steam_id.split("/")) {
        // console.log("格式1正确");
        this.form.steam_id = this.form.steam_id.split("/")[4];
      } else if (this.form.steam_id.length > 17 && this.form.steam_id.replace(/[ ]/g, "")) {
        // console.log("格式2正确");
        this.form.steam_id = this.form.steam_id.replace(/[ ]/g, "");
      } else if (this.form.steam_id.length == 17 && !this.form.steam_id.replace(/[ ]/g, "")) {
        // console.log("格式3正确");
        this.form.steam_id = this.form.steam_id.replace(/[ ]/g, "");
      } else if (this.form.steam_id.length == 17) {
        // console.log("格式3正确");
        this.form.steam_id = this.form.steam_id.replace(/[ ]/g, "");
      } else {
        return this.$message({
          message: "输入格式不正确，请重新输入",
          type: "warning",
        });
      }

      // if(this.userInfo.vip_time == 0 || Number(new Date()) > this.userInfo.vip_time){
      //   // 普通用户和vip超过有效期的会员需要判断每天的免费次数是否已超上限
      //   getPaymentCheck({ steam_id: set(this.form.steam_id) }).then(res => {
      //     console.log(res, 'getPaymentCheck');
      //     if(res && (res.code ?? 1) == 0) {
      //       this.$confirm(res.msg, '提示', {
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         confirmButtonClass: 'confirmSuccessBtn',
      //         closeOnClickModal: false,
      //         closeOnPressEscape: false
      //       }).then(() => {
      //         _this.$emit("fromData", this.form);
      //       }).catch(() => {        
      //       });
      //     } else {
      //       _this.$emit("fromData", this.form);
      //     }
      //   })
      // } else {
      //   this.$emit("fromData", this.form);
      // }

      this.$emit("fromData", this.form);
    },
    // 判断是否是时间格式
    strDateTime (str) {
      var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
      if (r == null) return false;
      var d = new Date(r[1], r[3] - 1, r[4]);
      return (d.getFullYear() == r[1] && (d.getMonth() + 1) == r[3] && d.getDate() == r[4]);
    },
    clickLive () {
      if (this.liveTypes == 0) {
        this.$message({
          message: "已开启主播模式",
          type: "success",
        });
        this.$store.commit("setLiveTypes", 1);
      } else {
        this.$message({
          message: "已关闭主播模式",
          type: "success",
        });
        this.$store.commit("setLiveTypes", 0);
      }
    },
    // 首次加载
    initHandle () {
      let that = this;
      setTimeout(function () {
        let swiper = that.$refs.videoSwiper.swiper;
        if (that.imgList[0]?.type === 1 && that.facility == "pc") {
          // document.getElementsByClassName('multimedia')[that.mediaLastIndex].muted = false;
          document
            .getElementsByClassName("multimedia")
          [that.mediaLastIndex].play();
          // that.$refs.videoPlayer[0].play()
        } else {
          that.imgListImgHandle(swiper);
        }
      }, 200);
    },
    // 获取banner数据
    async getBanner () {
      let _this = this;
      let param = {
        substation_id: set(_this.config.substationId),
      };
      await _this.$indexPost("/getBanner", param).then((res) => {
        // 网站信息
        _this.title = res.title;
        _this.info = res.menu.title;
        _this.imgList = res.banner;
        _this.help_id = res.help_id;
        _this.wechatImage = res.qrcode;
        _this.$store.commit('setOrderTypes', res.order)
      });
    },
    // 轮播切换
    imgListImgHandle (swiper) {
      let that = this;
      //刚切换到的activeIndex
      let changePointActiveIndex = swiper.activeIndex;
      if (swiper.activeIndex < this.imgList.length - 1) {
        setTimeout(function () {
          //要确认changePointActiveIndex是不是还是目前的activeIndex，是的话计时后执行，不是的话不执行
          if (changePointActiveIndex === swiper.activeIndex) {
            swiper.slideNext();
          }
        }, that.time);
      } else {
        setTimeout(function () {
          if (changePointActiveIndex === swiper.activeIndex) {
            swiper.slideTo(0, 0);
          }
        }, that.time);
      }
    },
    // 轮播开始
    slideChangeTransitionStartHandle () {
      // console.log("执行轮播开始");
      // let swiper = this.$refs.videoSwiper.swiper
      if (
        this.imgList[this.mediaLastIndex].type === 1 &&
        this.facility == "pc"
      ) {
        // this.$refs.videoPlayer.muted = false;
        document.getElementsByClassName("multimedia")[
          this.mediaLastIndex
        ].currentTime = 0;
      }
    },
    // 轮播结束
    slideChangeTransitionEndHandle () {
      // console.log('end..')
      // console.log("执行轮播结束");
      let that = this;
      let swiper = that.$refs.videoSwiper.swiper;
      if (
        this.imgList[this.mediaLastIndex].type === 1 &&
        that.facility == "pc"
      ) {
        // console.log("第一个和");

        document
          .getElementsByClassName("multimedia")
        [this.mediaLastIndex].pause();
      }
      if (
        this.imgList[swiper.activeIndex].type === 1 &&
        that.facility == "pc"
      ) {
        // document.getElementsByClassName('multimedia')[swiper.activeIndex].muted = false;
        // console.log("第二个和");
        document
          .getElementsByClassName("multimedia")
        [swiper.activeIndex].play();
      } else {
        this.imgListImgHandle(swiper);
      }
      this.mediaLastIndex = swiper.activeIndex;
    },
    // 视频播放完成轮播
    endVideo (index) {
      let swiper = this.$refs.videoSwiper.swiper;
      if (index === swiper.activeIndex) {
        if (swiper.activeIndex < this.imgList.length - 1) {
          swiper.slideNext();
          if (
            this.imgList[swiper.activeIndex].type === 1 &&
            this.facility == "pc"
          ) {
            // console.log(index,"视频播放1");
            // this.$refs.videoPlayer[index].muted = false;
            document
              .getElementsByClassName("multimedia")
            [swiper.activeIndex].play();
          } else {
            this.imgListImgHandle(swiper);
          }
        } else {
          swiper.slideTo(0, 0);
          if (
            this.imgList[swiper.activeIndex].type === 0 &&
            this.facility == "pc"
          ) {
            // console.log(index,"视频播放0");
            // this.$refs.videoPlayer[index].muted = false;
            document
              .getElementsByClassName("multimedia")
            [swiper.activeIndex].play();
          } else {
            this.imgListImgHandle(swiper);
          }
        }
      }
    },
    // 清掉采集信息
    clearSteamId () {
      this.form.steam_id = "";
    },
  },
  watch: {
    imgList: {
      handler (val) {
        this.initOrNot = false;
        this.$nextTick(() => {
          this.initOrNot = true;
        });
      },
      immediate: true,
      deep: true,
    },
    // liveTypes(n,o){
    //   this.liveTypes = n
    //   console.log(n,o,"n,o");
    // }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .swiper-wrapper {
  // top: 60px;
}

#video {
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
}

.multimedia {
  object-fit: cover;
  width: 100%;
  height: 100vh;
  // -webkit-filter: grayscale(30%);
}

.swiper-button-next {
  background: url("@/assets/img/swiper-right1.png") no-repeat;
  background-size: 100% 100%;
}

.swiper-button-prev {
  // border: #FFF;
  background: url("@/assets/img/swiper-left1.png") no-repeat;
  background-size: 100% 100%;
}

.info {
  span {
    margin-right: 12px;
  }
}

::v-deep .el-button--warning {
  color: #fff;
  background-color: #e49c18;
  border-color: #e49c18;
}

::v-deep .el-button--warning:hover {
  background: #eca12f;
  border-color: #ac782a;
}

.top_input {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(183, 233, 246, 0.05);
  border: 1px solid rgba(228, 228, 228, 0.55);
  // border-image: linear-gradient(135deg, #ffffff, rgba(228,228,228,0.75) 64%, rgba(255,255,255,0.61)) 1 1;
  border-radius: 16px;
  backdrop-filter: blur(15px);
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  // 标题
  .title {
    font-size: 24px;
    margin-bottom: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    color: #ffffff;
    line-height: 34px;
    letter-spacing: 0.02px;

    i {
      display: inline-block;
      width: 49px;
      height: 28px;
      background: url("@/assets/img/title_icon.png") no-repeat;
      background-size: 100% 100%;
      vertical-align: middle;
      margin-right: 10px;
    }
  }

  .info {
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    color: #ffffff;
    margin-bottom: 30px;
  }

  // 输入框
  .input_b {
    width: 620px;
    height: 53px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #2c9645;
    background-color: #fff;

    // overflow: hidden;
    input {
      background: none;
      outline: none;
      border: none;
    }

    input:focus {
      border: none;
    }

    input::placeholder {
      font-size: 15px;
    }

    .input_b_i {
      flex: 1;
      padding: 0 40px;
      font-size: 18px;
      // padding-left: 20px;
      // padding-right: 20px;

      &.active {
        // padding: 0 102px;
      }
    }

    .input_b_b {
      width: 117px;
      height: 53px;
      background: #2c9645;
      border: 1px solid #2c9645;
      border-radius: 0px 10px 10px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 18px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      letter-spacing: 0.02px;
      cursor: pointer;

      &.left {
        // width: auto;
        // padding: 0 10px;
        border-radius: 10px 0 0 10px;
      }
    }
  }

  .radio_body {
    width: 399px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    position: relative;

    .radio {
      font-size: 16px;
      position: relative;
      display: inline-block;
      font-weight: 400;
      color: #fff;
      padding-left: 25px;
      cursor: pointer;

      input {
        position: absolute;
        left: -9999px;
        align-items: center;

        &:after {
          position: absolute;
          content: "";
          top: 1px;
          left: 1px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #2c9645;
          opacity: 0;
          transition: opacity 0.1s;
          -webkit-transition: opacity 0.1s;
        }
      }

      i {
        display: block;
        position: absolute;
        top: 3px;
        left: 3px;
        width: 10px;
        height: 10px;
        outline: 0;
        border: 1px solid #e4e4e4;
        background: #ffffff;
        border-radius: 50%;
        transition: border-color 0.3s;
        -webkit-transition: border-color 0.3s;

        &:after {
          position: absolute;
          content: "";
          top: 1px;
          left: 1px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #2c9645;
          opacity: 0;
          transition: opacity 0.1s;
          -webkit-transition: opacity 0.1s;
        }
      }

      input:checked+i:after {
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

@media only screen and (min-width: 901px) {
  .top_input {
    width: 64%;
    height: 40%;
  }
}

@media screen and (min-width: 310px) and (max-width: 900px) {
  .top_input {
    width: 95%;
    height: 35%;
  }

  .input_b {
    width: 96% !important;
  }
}
</style>
<style lang="scss">
.confirmSuccessBtn {
  background-color: #2c9645 !important;

  &:hover {
    background-color: #1b7631 !important;
  }
}
</style>
